import React, { useState, useRef, useEffect } from 'react';
import type { Editor } from '@tiptap/core';

interface ImageDialogProps {
  editor: Editor;
  onClose: () => void;
}

export const ImageDialog: React.FC<ImageDialogProps> = ({ editor, onClose }) => {
  const [url, setUrl] = useState('');
  const [alt, setAlt] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (url) {
      editor.chain().focus().setImage({ src: url, alt: alt || undefined }).run();
    }

    onClose();
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="dialog-overlay" onClick={handleOverlayClick}>
      <div className="dialog-content">
        <h3>Insert Image</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="image-url">Image URL</label>
            <input
              ref={inputRef}
              id="image-url"
              type="text"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://example.com/image.jpg"
            />
          </div>
          <div className="form-group">
            <label htmlFor="image-alt">Alt Text (optional)</label>
            <input
              id="image-alt"
              type="text"
              value={alt}
              onChange={(e) => setAlt(e.target.value)}
              placeholder="Description of the image"
            />
          </div>
          <div className="dialog-actions">
            <button type="button" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-primary" disabled={!url}>
              Insert
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ImageDialog;
